import PropTypes from 'prop-types';
import React from 'react';
import modal from 'decorators/Modal/Modal';
export var ContentModalUnwrapped = function ContentModalUnwrapped(_ref) {
  var content = _ref.content;
  return React.createElement("div", {
    className: "modal__body"
  }, React.createElement("div", {
    className: "modal__column"
  }, content));
};
ContentModalUnwrapped.propTypes = {
  content: PropTypes.element.isRequired
};
export var ContentModal = modal()(ContentModalUnwrapped);